import { useQuery } from '@tanstack/react-query'
import { getMapboxToken } from '../utils/mapbox-token'

export const useMapBox = () => {
  const session = useQuery({
    queryKey: ['mapbox-token'],
    queryFn: async () => {
      const result = await getMapboxToken()
      return result
    },
    staleTime: 60 * 60 * 1000, // 1 hour
  })

  const result = {
    mapBoxToken: session.data ?? '',
  }

  return result
}
